import { produce } from 'immer';
import useConversationApi from './useConversationApi';

const useConversation = () => {
  const conversationApi = useConversationApi();

  const { data: conversations } = conversationApi.getConversations();
  const mutate = conversationApi.mutateConversations;

  const getTitle = (conversationId: string) => {
    return (
      conversations?.find((c) => c.id === conversationId)?.title ?? 'New Chat'
    );
  };

  const updateTitle = (conversationId: string, title: string) => {
    return mutate(async (current) => {
      await conversationApi.updateTitle(conversationId, title);

      return produce(current, (draft) => {
        const index = draft?.findIndex((c) => c.id === conversationId) ?? -1;
        if (index > -1) {
          draft?.splice(index, 1, {
            ...draft![index],
            title: title,
          });
        }
      });
    });
  };

  const updateTitleWithGeneratedTitle = async (conversationId: string, lang: string) => {
    const res = await conversationApi.updateTitleWithGeneratedTitle(conversationId, lang);
    return updateTitle(conversationId, res.data.title);
  };

  return {
    conversations,
    syncConversations: () => {
      return mutate(conversations);
    },
    getTitle,
    getBotId: (conversationId: string) => {
      return conversations?.find((c) => c.id === conversationId)?.botId ?? null;
    },
    deleteConversation: (conversationId: string) => {
      return mutate(async (current) => {
        await conversationApi.deleteConversation(conversationId);

        return produce(current, (draft) => {
          const index = draft?.findIndex((c) => c.id === conversationId) ?? -1;
          if (index > -1) {
            draft?.splice(index, 1);
          }
        });
      });
    },
    clearConversations: () => {
      return mutate(async () => {
        await conversationApi.clearConversations();
        return [];
      });
    },
    updateTitle,
    updateTitleWithGeneratedTitle, // 修正した関数を返す
  };
};

export default useConversation;
